// extracted by mini-css-extract-plugin
module.exports = {"input":"Tick_input__qpKo8","disabled":"Tick_disabled__0uEK5"};